import axiosInstance from './axiosConfig';

export const postLogin = async (credentials: { email: string, password: string }) => {
    const response = await axiosInstance.post('/auth/login', credentials);
    return response?.data;
};

export const postLogout = async () => {
    const response = await axiosInstance.post('/auth/logout');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    return response?.data;
};

export const postForgetPwd = async (email: string) => {
    const response = await axiosInstance.post('/auth/forgot-password', { email });
    return response?.data;
};

export const postResetPwd = async (token: string, password: string) => {
    const response = await axiosInstance.post('/auth/reset-password', { password }, { params: { token } });
    return response?.data;
};
